import { Component, computed, ElementRef, inject, input, model, viewChild, output} from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatInput } from "@angular/material/input";
import { FormsModule } from "@angular/forms";
import { LanguageService } from "../../services/language.service";

@Component({
  selector: "vl-input-search",
  standalone: true,
  imports: [MatIcon, MatInput, FormsModule],
  templateUrl: "./input-search.component.html",
  styleUrl: "./input-search.component.scss",
})
export class InputSearchComponent {
  private languageService = inject(LanguageService);
  value = model();
  placeholder = input<string>();
  canCreate = input<boolean>(false);
  createAction = output();
  inputElement = viewChild<ElementRef<HTMLInputElement>>("inputEl");
  resolvedPlaceholder = computed(() => {
    const custom = this.placeholder();
    if (custom) return custom;
    return this.languageService.messages()?.['search']?.['label'] ?? 'Rechercher...';
  });

  focus() {
    this.inputElement()?.nativeElement?.focus();
  }
}
